/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "roster": {
        "nested": {
          "mds_audit_log": {
            "nested": {
              "MdsActor": {
                "fields": {
                  "actorType": {
                    "type": ".squareup.roster.mds_audit_log.MdsActor.ActorType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "actorId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ActorType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "SQUARE_LDAP": 1,
                      "PERSON_TOKEN": 2,
                      "EXTERNAL_APP": 3,
                      "REGISTRY_APP": 4
                    }
                  }
                }
              },
              "MdsField": {
                "values": {
                  "DO_NOT_USE": 0,
                  "MERCHANT_IS_ACTIVE": 1,
                  "MERCHANT_LANGUAGE": 2,
                  "MERCHANT_2FA": 3,
                  "MERCHANT_NAME": 4,
                  "MERCHANT_USE_SAVINGS": 5,
                  "MERCHANT_USE_POINT_OF_SALE": 35,
                  "MERCHANT_USE_DEVELOPER_DASHBOARD": 36,
                  "MERCHANT_USE_APPOINTMENTS": 37,
                  "MERCHANT_USE_RESTAURANTS": 38,
                  "MERCHANT_USE_PAYROLL": 39,
                  "MERCHANT_SELL_CBD": 40,
                  "MERCHANT_USE_RULE_BASED_TAXES": 41,
                  "MERCHANT_USE_ITEMS_AUTOSKU": 42,
                  "MERCHANT_SELL_CANNABIS": 53,
                  "MERCHANT_IS_SANDBOX": 54,
                  "MERCHANT_USE_BTC_TREASURY": 55,
                  "MERCHANT_USE_ELEVATED_TIP_LIMIT": 57,
                  "MERCHANT_USE_GIFT_CARDS": 59,
                  "MERCHANT_APPLE_TAP_TO_PAY_LINKED": 60,
                  "MERCHANT_APPLE_TAP_TO_PAY_ENABLED": 61,
                  "MERCHANT_APPLE_TAP_TO_PAY_OPT_IN_SEEN": 62,
                  "MERCHANT_USE_HOUSE_ACCOUNTS": 63,
                  "MERCHANT_CHANGE_NAME_WITHOUT_LIMIT": 65,
                  "MERCHANT_USE_GIFT_CARD_SETTLEMENT": 66,
                  "MERCHANT_IS_TEST_MERCHANT": 70,
                  "MERCHANT_APPLE_TAP_TO_PAY_MKE_DISMISSED": 71,
                  "MERCHANT_PAYMENT_LINK_MKE_DISMISSED": 72,
                  "MERCHANT_INVOICE_MKE_DISMISSED": 73,
                  "MERCHANT_USE_DUAL_MODE_V2_PAYG": 75,
                  "MERCHANT_USE_DUAL_MODE_V2_POS": 76,
                  "MERCHANT_USE_THIRD_PARTY_GIFT_CARD_PROVIDER": 77,
                  "MERCHANT_ENABLE_MODERN_MICROS_MODE": 78,
                  "MERCHANT_REPRICE_1_6_CP_AU_RATES": 79,
                  "MERCHANT_JP_SMIRF_PRICING_ELIGIBLE": 81,
                  "MERCHANT_SHOW_THIRD_PARTY_GIFT_CARD_PROVIDER_ONBOARDING": 82,
                  "UNIT_IS_ACTIVE": 6,
                  "UNIT_IS_MOBILE": 7,
                  "UNIT_BUSINESS_TYPE": 8,
                  "UNIT_TIME_ZONE": 9,
                  "UNIT_LANGUAGE": 10,
                  "UNIT_PRIMARY_ADDRESS": 11,
                  "UNIT_BUSINESS_NAME": 12,
                  "UNIT_NICKNAME": 13,
                  "UNIT_COORDINATES": 14,
                  "UNIT_WEBSITE_URL": 15,
                  "UNIT_FACEBOOK_URL": 16,
                  "UNIT_TWITTER_USERNAME": 17,
                  "UNIT_INSTAGRAM_USERNAME": 18,
                  "UNIT_PHONE_NUMBER": 19,
                  "UNIT_BUSINESS_EMAIL": 20,
                  "UNIT_BUSINESS_HOURS": 21,
                  "UNIT_SPECIAL_BUSINESS_HOURS": 64,
                  "UNIT_IMAGES": 22,
                  "UNIT_ACCEPT_PAYMENT_CARDS": 23,
                  "UNIT_ACCEPT_HIGH_TRANSACTIONS": 43,
                  "UNIT_ACCEPT_JPY_JCB_PAYMENT_CARDS": 44,
                  "UNIT_DECLINE_ALL_AUTHORIZATIONS": 45,
                  "UNIT_OVERRIDE_AU_UNSUPPORTED_BUSINESS": 46,
                  "UNIT_REJECT_ALL_REFUNDS": 47,
                  "UNIT_SKIP_PAYMENT_TUTORIALS": 48,
                  "UNIT_GET_INTRODUCTORY_PAYMENT_NOTICE": 56,
                  "UNIT_CHECK_FOR_LOAN_WITHHOLDINGS": 58,
                  "UNIT_USE_LOCAL_OFFERS_BILLING": 67,
                  "UNIT_GB_VAT": 49,
                  "UNIT_EU_VAT": 50,
                  "UNIT_FR_SIRET": 51,
                  "UNIT_FR_NAF": 52,
                  "UNIT_JP_QII": 68,
                  "UNIT_IS_TEST_UNIT": 69,
                  "UNIT_ACCEPT_PAYMENTS_ANYWHERE": 74,
                  "UNIT_CHECK_FOR_RISK_RESERVES": 80,
                  "UNIT_AU_ABN": 83,
                  "UNIT_AU_ACN": 84,
                  "EMPLOYMENT_IS_ACTIVE": 24,
                  "EMPLOYMENT_IS_AUTHORIZED_USER": 25,
                  "EMPLOYMENT_ROLE_TOKEN": 26,
                  "EMPLOYMENT_AUTHORIZED_LOCATIONS": 27,
                  "EMPLOYMENT_FIRST_NAME": 28,
                  "EMPLOYMENT_LAST_NAME": 29,
                  "ROLE_IS_FULL_ACCESS": 30,
                  "ROLE_PERMISSIONS": 31,
                  "ROLE_MANAGED_ROLE_TOKENS": 32,
                  "ROLE_NAME": 33,
                  "ROLE_PASSCODE_UPDATED_AT": 34,
                  "UNIT_SCRIPT_ADDRESS": 85
                }
              },
              "AuditLog": {
                "fields": {
                  "changes": {
                    "type": ".squareup.roster.mds_audit_log.AuditLogChange",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "clientApplication": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "actor": {
                    "type": ".squareup.roster.mds_audit_log.MdsActor",
                    "id": 3,
                    "rule": "optional"
                  },
                  "loggedTs": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "version": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "AuditLogChange": {
                "fields": {
                  "mdsField": {
                    "type": ".squareup.roster.mds_audit_log.MdsField",
                    "id": 1,
                    "rule": "optional"
                  },
                  "oldValue": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "newValue": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "GetAuditLogsRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "entityToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "GetAuditLogsResponse": {
                "fields": {
                  "logs": {
                    "type": ".squareup.roster.mds_audit_log.AuditLog",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.roster?.nested?.mds_audit_log?.nested?.MdsActor && !$root.nested?.squareup?.nested?.roster?.nested?.mds_audit_log?.nested?.MdsActor?.nested?.ActorType && !$root.nested?.squareup?.nested?.roster?.nested?.mds_audit_log?.nested?.MdsField && !$root.nested?.squareup?.nested?.roster?.nested?.mds_audit_log?.nested?.AuditLog && !$root.nested?.squareup?.nested?.roster?.nested?.mds_audit_log?.nested?.AuditLogChange && !$root.nested?.squareup?.nested?.roster?.nested?.mds_audit_log?.nested?.GetAuditLogsRequest && !$root.nested?.squareup?.nested?.roster?.nested?.mds_audit_log?.nested?.GetAuditLogsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE MdsActor @ squareup/roster/mds_audit_log.proto at 7:1
 */
export const MdsActor = $root.lookupType('squareup.roster.mds_audit_log.MdsActor');
fixType(MdsActor);
Builder.createAndAttachToType(MdsActor);
/**
 * An authenticated entity that can change merchant data.
 *
 * SOURCE ActorType @ squareup/roster/mds_audit_log.proto at 10:3
 */
MdsActor.ActorType = $root.lookupEnum('squareup.roster.mds_audit_log.MdsActor.ActorType').values;
/**
 * SOURCE MdsField @ squareup/roster/mds_audit_log.proto at 33:1
 */
export const MdsField = $root.lookupEnum('squareup.roster.mds_audit_log.MdsField').values;
/**
 * SOURCE AuditLog @ squareup/roster/mds_audit_log.proto at 482:1
 */
export const AuditLog = $root.lookupType('squareup.roster.mds_audit_log.AuditLog');
fixType(AuditLog);
Builder.createAndAttachToType(AuditLog);
/**
 * SOURCE AuditLogChange @ squareup/roster/mds_audit_log.proto at 499:1
 */
export const AuditLogChange = $root.lookupType('squareup.roster.mds_audit_log.AuditLogChange');
fixType(AuditLogChange);
Builder.createAndAttachToType(AuditLogChange);
/**
 * SOURCE GetAuditLogsRequest @ squareup/roster/mds_audit_log.proto at 527:1
 */
export const GetAuditLogsRequest = $root.lookupType('squareup.roster.mds_audit_log.GetAuditLogsRequest');
fixType(GetAuditLogsRequest);
Builder.createAndAttachToType(GetAuditLogsRequest);
/**
 * SOURCE GetAuditLogsResponse @ squareup/roster/mds_audit_log.proto at 546:1
 */
export const GetAuditLogsResponse = $root.lookupType('squareup.roster.mds_audit_log.GetAuditLogsResponse');
fixType(GetAuditLogsResponse);
Builder.createAndAttachToType(GetAuditLogsResponse);